<template>
  <div id="dashboard">
    <div class="pane">
      <div class="module title large">Regent Dashboard</div>
      <KeyManager></KeyManager>
      <ConnectedClients v-if="$store.state.ws_connected"></ConnectedClients>

      <div class="module" v-if="$store.state.ws_connected">
        <div class="medium header">Send messages</div>
        <div class="msgs">
          <SendWSMsg v-for="(msg,idx) in $store.state.ws_messages" :key="idx"
            :message="msg.message" :channel="msg.channel" :label="msg.label" :timeout="msg.timeout"
          ></SendWSMsg>
        </div>
      </div>
    </div>

    <div class="pane">
      <Log></Log>
    </div>

    <WS></WS>
  </div>
</template>

<script>
import KeyManager from '../components/KeyManager.vue';
import Log from '../components/Log.vue';
import WS from '../components/WS.vue';
import ConnectedClients from '../components/ConnectedClients.vue';
import SendWSMsg from '../components/SendWSMsg.vue';

export default {
  name: 'app',
  components: {
    KeyManager,
    Log,
    WS,
    ConnectedClients,
    SendWSMsg
  },
  created () {
  }
};
</script>

<style lang="scss">
#dashboard {
  display: flex;
  flex-direction: row;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

.title {
  background-image:url(../assets/soso.png);
  background-repeat: no-repeat;
  background-position: calc(100% - 30px) center;
  background-size: 150px;
}

.pane {
  flex-basis: 50%;
  height: 100vh;
  max-width: 50%;
  overflow-y: auto;
}

.msgs {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
</style>
